export default __webpack_public_path__ + "static/yahoo-c5ab80f984b6c9120ea26d0196440bea.svg";